export async function parseRtf(file: File): Promise<string> {
  const rtfContent = await file.text()
  return extractTextFromRtf(rtfContent)
}

function extractTextFromRtf(rtf: string): string {
  // Remove RTF header
  let text = rtf

  // Remove control groups like {\fonttbl...}, {\colortbl...}, {\stylesheet...}, etc.
  text = removeControlGroups(text)

  // Handle escaped characters (e.g., \'e9 for accented characters)
  text = decodeEscapedCharacters(text)

  // Convert paragraph and line breaks to newlines
  text = text.replace(/\\par\b/g, '\n')
  text = text.replace(/\\line\b/g, '\n')

  // Remove all other control words (e.g., \b0, \i0, \ul0, \fs24, etc.)
  text = text.replace(/\\[a-z]+\d*\s?/gi, '')

  // Remove remaining braces
  text = text.replace(/[{}]/g, '')

  // Remove the RTF version marker if still present
  text = text.replace(/rtf\d+/g, '')

  // Clean up multiple newlines
  text = text.replace(/\n{3,}/g, '\n\n')

  // Trim whitespace
  text = text.trim()

  return text
}

function removeControlGroups(rtf: string): string {
  // Remove nested control groups like {\fonttbl...}, {\colortbl...}, {\*\...}
  const controlGroupPatterns = [
    /\{\\fonttbl[^{}]*(?:\{[^{}]*\}[^{}]*)*\}/g,
    /\{\\colortbl[^{}]*\}/g,
    /\{\\stylesheet[^{}]*(?:\{[^{}]*\}[^{}]*)*\}/g,
    /\{\\info[^{}]*(?:\{[^{}]*\}[^{}]*)*\}/g,
    /\{\\\*\\[^{}]*(?:\{[^{}]*\}[^{}]*)*\}/g,
    /\{\\header[^{}]*(?:\{[^{}]*\}[^{}]*)*\}/g,
    /\{\\footer[^{}]*(?:\{[^{}]*\}[^{}]*)*\}/g,
  ]

  let result = rtf
  for (const pattern of controlGroupPatterns) {
    result = result.replace(pattern, '')
  }

  // Remove the opening RTF declaration
  result = result.replace(/^\{\\rtf\d+\\[^{}]*/, '')

  return result
}

function decodeEscapedCharacters(text: string): string {
  // Handle \'XX hex escape sequences
  return text.replace(/\\'([0-9a-fA-F]{2})/g, (_, hex) => {
    const charCode = parseInt(hex, 16)
    return String.fromCharCode(charCode)
  })
}
